<template>

    <v-action name="Font Style">
        <v-button-group>
            <a class="btn" :class="{ active: model.font_weight === 'bold' }" href="#" @click.prevent="onInput('font_weight')">
                <i class="fas fa-bold"></i>
            </a>
            <a class="btn" :class="{ active: model.font_style === 'italic' }" href="#" @click.prevent="onInput('font_style')">
                <i class="fas fa-italic"></i>
            </a>
            <a class="btn" :class="{ active: model.text_decoration === 'underline' }" href="#" @click.prevent="onInput('text_decoration')">
                <i class="fas fa-underline"></i>
            </a>
            <a class="btn" :class="{ active: model.text_transform === 'uppercase' }" href="#" @click.prevent="onInput('text_transform')">
                <i class="fas fa-font-case"></i>
            </a>
        </v-button-group>
    </v-action>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .btn {
        align-items: center;
        display: flex;
        height: 30px;
        justify-content: center;
        transition: background-color .3s;
        &:hover {
            background-color: $color-bg;
        }
        &.active i {
            color: $color-primary;
        }
        i {
            font-size: 14px;
        }
    }

</style>

<script>

import Action from './Action';

export default {

    props: {
        container: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        'v-action': Action,
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        model() {
            return {
                font_weight: this.block.font_weight ? this.block.font_weight : 'normal',
                font_style: this.block.font_style ? this.block.font_style : 'normal',
                text_decoration: this.block.text_decoration ? this.block.text_decoration : 'none',
                text_transform: this.block.text_transform ? this.block.text_transform : 'none',
            };
        },

    },

    methods: {

        onInput(key) {
            if (key === 'font_weight') {
                this.model[key] = this.model[key] === 'bold' ? 'normal' : 'bold';
            }
            if (key === 'font_style') {
                this.model[key] = this.model[key] === 'italic' ? 'normal' : 'italic';
            }
            if (key === 'text_decoration') {
                this.model[key] = this.model[key] === 'underline' ? 'none' : 'underline';
            }
            if (key === 'text_transform') {
                this.model[key] = this.model[key] === 'uppercase' ? 'none' : 'uppercase';
            }
            let block = this.block;
            block[key] = this.model[key];
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>